<template>
    <v-app id="inspire">
        <Navigation></Navigation>
        <AppBar
                :title="pageTitle"
                :actions="appBarActions"
        />
        <v-content>
            <v-container>

                <v-row>
                    <v-col>
                        <v-text-field
                                v-model="searchInput"
                                label="Search"
                                prepend-inner-icon="search"
                                placeholder="User email, key domain or public key"
                                outlined
                                @keyup="search()"
                                @click:clear="clearSearch()"
                                :rules="[rules.searchLength]"
                                clearable
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-card>
                            <v-data-table
                                    :headers="headers"
                                    :items="items"
                                    :items-per-page="-1"
                                    hide-default-footer
                                    class="elevation-1"
                            >
                                <template v-slot:item.status="{ item }">
                                    <v-badge
                                            bordered
                                            :color="statusColor(item.status)"
                                            dot
                                            left
                                            offset-x="10"
                                            offset-y="10"
                                    >
                                        <v-chip
                                                :color="statusColor(item.status) + ' lighten-5'"
                                        >
                                            {{ item.statusAlias }}
                                        </v-chip>
                                    </v-badge>
                                </template>
                                <template v-slot:item.date_created="{ item }">
                                    {{ dFormat(item.date_created, "mmmm d, yyyy, HH:MM:ss") }}
                                </template>
                                <template v-slot:item.lp_api_keys_count="{ item }">
                                    <v-badge
                                            bordered
                                            color="grey"
                                            dot
                                            left
                                            offset-x="10"
                                            offset-y="10"
                                    >
                                        <v-chip
                                                :color="'grey' + ' lighten-5'"
                                        >
                                            {{item.lp_api_keys_count}}
                                        </v-chip>
                                    </v-badge>
                                    <v-badge v-if="item.lp_api_keys_info[1] !== 0"
                                             bordered
                                             :color="statusColor(1)"
                                             dot
                                             left
                                             offset-x="10"
                                             offset-y="10"
                                    >
                                        <v-chip
                                                :color="statusColor(1) + ' lighten-5'"
                                        >
                                            {{ item.lp_api_keys_info[1] }}
                                        </v-chip>
                                    </v-badge>
                                    <v-badge v-if="item.lp_api_keys_info[2] !== 0"
                                             bordered
                                             :color="statusColor(2)"
                                             dot
                                             left
                                             offset-x="10"
                                             offset-y="10"
                                    >
                                        <v-chip
                                                :color="statusColor(2) + ' lighten-5'"
                                        >
                                            {{ item.lp_api_keys_info[2] }}
                                        </v-chip>
                                    </v-badge>
                                    <v-badge v-if="item.lp_api_keys_info[0] !== 0"
                                             bordered
                                             :color="statusColor(0)"
                                             dot
                                             left
                                             offset-x="10"
                                             offset-y="10"
                                    >
                                        <v-chip
                                                :color="statusColor(0) + ' lighten-5'"
                                        >
                                            {{ item.lp_api_keys_info[0] }}
                                        </v-chip>
                                    </v-badge>
                                </template>
                                <template v-slot:item.id="{ item }">
                                    <v-btn fab x-small color="blue lighten-4" :to="{ name: 'user/edit', params: { id: item.id }}">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn fab x-small color="red lighten-1" @click="openDeleteDialog([{ id:item.id, text: item.email }] )" class="ml-1">
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-pagination
                                v-model="page"
                                :length="total"
                                :total-visible="7"
                                @input="next"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>

        <v-snackbar
                v-model="snackbarShow"
                top
                right
                :timeout="4000"
                :color="snackbarColor"
        >
            {{ snackbarText }}
            <v-btn
                    x-small
                    text
                    fab
                    @click="snackbarShow = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

        <v-dialog v-model="deleteDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>Delete users</v-card-title>
                <v-card-text>
                    <v-label>Items to delete</v-label>
                    <v-flex>
                        <v-chip v-for="item in deleteItems" :key="item.id">{{item.text}}</v-chip>
                    </v-flex>
                </v-card-text>
                <v-card-text>
                    <v-label>Are you sure?</v-label>
                </v-card-text>
                <v-card-actions class="px-5">
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="del" :loading="loading" :disabled="loading">Delete</v-btn>
                    <v-btn color="dark"  @click="closeDeleteDialog" :disabled="loading" >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>
<script>

    const dateFormat = require('dateformat');

    export default {
        name: "Users",
        props: {
            pageTitle: {
                type: String,
                default: 'Users List'
            }
        },
        data(){
            return {
                appBarActions: [
                    {
                        title: "Add user",
                        icon: 'mdi-plus',
                        color: 'grey darken-2',
                        to: {  name: 'user/add' }
                    },
                ],
                headers : [
                    { text: 'Name', sortable: false, align: 'start', value: 'name' },
                    { text: 'Email', sortable: false, align: 'start', value: 'email' },
                    { text: 'User Status', sortable: false, align: 'start', value: 'status' },
                    // { text: 'RS API-keys', sortable: false, align: 'start', value: 'api_keys_count' },
                    { text: 'LP API-keys', sortable: false, align: 'start', value: 'lp_api_keys_count' },
                    { text: 'Created', sortable: false, align: 'start', value: 'date_created' },
                    { text: 'Action', sortable: false, align: 'end', value: 'id' },
                ],
                loading: false,
                snackbarColor: 'success',
                snackbarShow: false,
                snackbarText: '',
                deleteDialog: false,
                deleteItems: [],
                page    : 1,
                total   : 0,
                items   : [],

                searchInput: '',
                rules:{
                    searchLength: v =>  v === null || v.length > 2 || v.length === 0  || "3 or more"
                },
            }
        },
        created(){
            this.buildList();
        },
        methods:{

            dFormat( date, mask, utc, gmt ){
                return dateFormat( date, mask, utc, gmt );
            },

            setAlert( color, text ) {
                this.snackbarColor = color;
                this.snackbarText  = text;
                this.snackbarShow  = true;
            },

            openDeleteDialog( items ) {
                this.deleteDialog = true;
                this.deleteItems = items;
            },

            closeDeleteDialog() {
                this.deleteDialog = false;
                this.deleteItems = [];
            },

            statusColor( status = null ){
                const colors = {
                    '0': 'red',
                    '1': 'green',
                    '2': 'yellow',
                };

                return colors.hasOwnProperty(status) ? colors[status] : 'grey'
            },

            buildList() {

                this.loading = true;

                this.axios.post( 'user/list', JSON.stringify( {
                    pageNo   : this.page,
                    pageSize : 20,
                    search: this.searchInput
                } ) )
                .then((response)=>{

                    const params = response.data;

                    if(params.status === 'success' && params.hasOwnProperty('data') ){
                        this.items = params.data.users;
                        this.total = params.data.total;
                    } else {
                        this.items = [];
                        this.total = 0;
                    }

                    this.loading = false;

                }).catch(()=>{

                    this.setAlert('error', 'Data has not been received');
                    this.loading = false;
                });
            },

            next (page) {
                this.page = page;
                this.buildList();
            },

            del(){

                this.loading = true;

                this.axios.post( 'user/bulkDelete', JSON.stringify({
                    items  : this.deleteItems,
                }) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {

                        this.setAlert('success', params.message );

                        this.deleteDialog = false;
                        this.deleteItems = [];

                        this.buildList();
                    } else {
                        this.setAlert('error', params.message);
                    }

                    this.loading = false;

                } ).catch( (reject) => {
                    this.setAlert('error', reject);
                    this.loading = false;
                } );

            },

            search() {

                if( this.searchInput === null ) {
                    this.searchInput = '';
                }

                if( this.searchInput.length > 2 || this.searchInput.length === 0 ){
                    this.page = 1;
                    this.buildList();
                }
            },

            clearSearch(){
                this.searchInput = '';
                this.search();
            },

        }
    }
</script>